import {
  useAllValidAnimals,
  useBillingInterval,
  getCurrentDraftForAnimal,
  useTotalCost,
  useTotalYearlyCost,
} from "components/Signup/store/selectors/animals";
import { Typography } from "ui-kit/Typography";
import { getAmountToPay } from "utils/insurance/getAmountToPay";
import { formatCurrency } from "utils/utils";
import { TotalRow } from "../TotalRow";
import styles from "./SummaryStatement.module.css";
import { TypographyVariant } from "ui-kit/Typography/types";

export function SummaryStatement({ hideTotalRow }: { hideTotalRow?: boolean }) {
  const animals = useAllValidAnimals();
  const billingInterval = useBillingInterval();
  const totalCost = useTotalCost();
  const totalYearlyCost = useTotalYearlyCost();

  return (
    <div className={styles.container}>
      {animals.length > 1 ? (
        <div>
          {animals.map((animal) => {
            const currentDraft = getCurrentDraftForAnimal(animal);

            if (!currentDraft) {
              return null;
            }
            const amountToPay = getAmountToPay({
              ...currentDraft,
              billingInterval,
            });
            return (
              <div
                key={animal.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 16,
                }}
              >
                <Typography variant="body2" color="grey500">
                  {animal.name}
                </Typography>
                <div
                  style={{ display: "flex", alignItems: "baseline", gap: 8 }}
                >
                  <Typography variant="body3" color="grey400">
                    <s>
                      {amountToPay.old ? formatCurrency(amountToPay.old) : null}
                    </s>
                  </Typography>
                  <Typography variant="body2" className={styles.rowAmount}>
                    <strong>{formatCurrency(amountToPay.new)}</strong>
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
      {hideTotalRow ? null : (
        <TotalRow
          amountToPay={totalCost}
          amountToPayYearly={totalYearlyCost}
          billingInterval={billingInterval}
          textVariant={TypographyVariant.h3}
        />
      )}
    </div>
  );
}
